import React from 'react'
import Work from './Work'

const Project = () => <Work />

export default Project
